import React, { FC, useEffect } from "react";
import Card8 from "componentsTemplate/Card8/Card8";
import Card9 from "componentsTemplate/Card9/Card9";
import { SectionMagazine1Props } from "componentsTemplate/Sections/SectionMagazine1";
import HeaderFilter from "componentsTemplate/Sections/HeaderFilter";

export interface SectionPostsProps extends SectionMagazine1Props {}

const SectionPosts: FC<SectionPostsProps> = ({
  posts,
  className = "",
  heading = "Latest Articles 🎈",
}) => {

  return (
    <div className={`nc-SectionMagazine4 ${className}`}>
      <HeaderFilter
        heading={heading}
        subHeading="Um mundo de conexões entre as mulheres Radares em diversos universos."
      />

      {!posts?.length && <span>Nothing we found!</span>}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
        {posts[0] && (
          <Card8
            hoverInteracition={false}
            className="sm:col-span-2"
            post={posts[0]}
          />
        )}
        {posts
          .filter((_, i) => i < 3 && i >= 1)
          .map((item, index) => (
            <Card9 hoverInteracition={false} key={index} post={item} />
          ))}
        {posts
          .filter((_, i) => i < 5 && i >= 3)
          .map((item, index) => (
            <Card9 hoverInteracition={false} key={index} post={item} />
          ))}
        {posts[5] && (
          <Card8
            hoverInteracition={false}
            className="sm:col-span-2"
            post={posts[5]}
          />
        )}
      </div>
    </div>
  );
};

export default SectionPosts;
